import { useEffect, useState } from 'react';
const useScrollPosition = ({
  targetRef
} = {}) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    // If the ref is not provided or its current value is null, fall back to document
    const target = targetRef?.current || document;
    const scrollable = target === document ? window : target;
    let frame = null;

    // Scroll fires far more often than once per frame. Reading/committing on every
    // event re-renders the layout provider dozens of times per frame, which is what
    // made scrolling stutter. Coalesce to one state update per animation frame.
    const updatePosition = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        // Determine if we're scrolling the document or a specific element
        const scrollY = target === document ? window.scrollY : target.scrollTop;
        setScrollPosition((prev) => (prev === scrollY ? prev : scrollY));
      });
    };
    // Passive: we never preventDefault here, and a non-passive listener forces the
    // browser to block scrolling until this handler returns.
    scrollable.addEventListener('scroll', updatePosition, { passive: true });

    // Set the initial position
    updatePosition();
    return () => {
      if (frame !== null) {
        cancelAnimationFrame(frame);
      }
      scrollable.removeEventListener('scroll', updatePosition);
    };
  }, [targetRef]);
  return scrollPosition;
};
export { useScrollPosition };
